import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BoardPage } from "@/features/board/BoardPage";

/**
 * The board filter, as written in the address bar. Each value is a plain
 * comma list, parsed and cleaned by parseFilter, so a hand-edited or stale
 * link degrades to a looser filter instead of an error page.
 */
const BoardSearchSchema = z.object({
  assignee: z.string().optional().catch(undefined),
  label: z.string().optional().catch(undefined),
  priority: z.string().optional().catch(undefined),
  completed: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_app/projects/$projectKey")({
  validateSearch: BoardSearchSchema,
  component: BoardPage,
});
